module.exports = "/static/assets/d667efad2534ade6f4b440ed816ff039.png";